import api from './api'

// NOTE: the winning competitor's identity and value are not exposed to agents.
// Only the exact percentage above the winner is (differencePercent, Plane #9).

export interface LostOffer {
  id: string
  status: 'declined' | 'expired'
  currency: string
  totalValue: number
  totalValueBRL: number | null
  totalValueUSD: number | null
  totalsByCurrency: Record<string, number> | null
  exchangeRateUsed: number | null
  exchangeRateSource: string | null
  declinedAt: string | null
  declinedReason: string | null
  validityDate: string | null
  deliveryTime: number | null
  createdAt: string
  rankPosition: number
  totalCompetitors: number
  differencePercent: number | null

  quoteId: string
  quoteTxControl: string
  modalityName: string | null
  modalityType: string | null
  incoterm: string | null
  origin: { location: { city: string; state?: string; country: string } } | null
  destination: { location: { city: string; state?: string; country: string } } | null
  shipperName: string
  shipperTradingName: string | null
}

export interface LostOffersSummary {
  total: number
  declined: number
  expired: number
  totalValueUsd: number
  avgDifferencePercent: number | null
}

export async function fetchLostOffers(): Promise<{ items: LostOffer[]; summary: LostOffersSummary }> {
  const res = await api.get<{ items: LostOffer[]; summary: LostOffersSummary }>('/freight-forwarder/lost-offers')
  return res.data
}
